module.exports = false;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/client/~/core-js/internals/is-pure.js
// module id = bprS
// module chunks = 0 3